export default "__VITE_ASSET__BnGNM9Jl__"